import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ClassList from "./ClassList";
import ClassForm from "./ClassForm";
import ClassDetail from "./ClassDetail";
import SessionDetail from "./SessionDetail";
import SessionEditor from "./SessionEditor";

const ClassMgmtView = () => (
  <Routes>
    <Route index element={<ClassList />} />
    <Route path="new" element={<Navigate to="/admin/classes-mgmt" replace />} />
    <Route path=":id" element={<ClassDetail />} />
    <Route path=":id/sessions/new" element={<SessionEditor />} />
    <Route path=":id/sessions/:sessionId" element={<SessionDetail />} />
    <Route path=":id/sessions/:sessionId/edit" element={<SessionEditor />} />
    <Route path=":id/edit" element={<ClassForm />} />
  </Routes>
);

export default ClassMgmtView;
